const PAGE_SIZE = 30;

export { PAGE_SIZE };
